import { render, staticRenderFns } from "./friday.vue?vue&type=template&id=71419899&scoped=true&"
import script from "./friday.vue?vue&type=script&lang=js&"
export * from "./friday.vue?vue&type=script&lang=js&"
import style0 from "./friday.vue?vue&type=style&index=0&id=71419899&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71419899",
  null
  
)

export default component.exports